<template>
    <b-tabs type="is-toggle-rounded" expanded>
        <loading
            :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="false">
        </loading>
        <b-tab-item label="Normal">
            <item-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="behaviorData in dataList" :behaviorData="behaviorData" v-bind:key="behaviorData.key" v-show="behaviorData.dataType==1"></item-view>
        </b-tab-item>
        <b-tab-item label="Attendance">
            <item-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="behaviorData in dataList" :behaviorData="behaviorData" v-bind:key="behaviorData.key" v-show="behaviorData.dataType==2"></item-view>
        </b-tab-item>
        <b-tab-item label="Subject Attendance">
            <item-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="behaviorData in dataList" :behaviorData="behaviorData" v-bind:key="behaviorData.key" v-show="behaviorData.dataType==5"></item-view>
        </b-tab-item>
        <b-tab-item label="Parents">
            <item-view v-on:delete-data="deleteData" v-on:update-data="updateData" v-for="behaviorData in dataList" :behaviorData="behaviorData" v-bind:key="behaviorData.key" v-show="behaviorData.dataType==4"></item-view>
        </b-tab-item>
    </b-tabs>
</template>

<style scoped>
.box{
    border: 1px solid #ccc;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>
<script>
import ItemView from './ItemView';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    data() {
        return {
            isLoading: false,
        };
    },
    created() {
    },
    props: ['dataList'],
    components: {
        ItemView,
        Loading,
    },
    methods: {
        deleteData(data) {
            if (data.addedBy == "system"){
                Toast.open({
                    message: "This behavior was added by the system. It can only be edited, and not deleted.",
                    type: 'is-warning', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 5000
                })
            }else{
                this.$swal({
                    title: "Are you sure?",
                    text: "Do you really want to remove item " + data.name + "?",
                    showCancelButton: true,
                    confirmButtonText: `Yes, remove`,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        const dataIndex = this.dataList.indexOf(data);
                        this.dataList.splice(dataIndex, 1);

                        axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
                        axios.defaults.responseType = "json";
                        axios.post(process.env.MY_URL + "/super/item/remove", {
                            superEmail: localStorage.getItem("superEmail"),
                            _id: data._id,
                        }).then(response => {
                            if (response.data.success == true) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
                            } else {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            }
                        })
                        .catch(e => {
                            console.log(e.response)
                            if (e.response.status === 401) {
                                console.log("salah login")
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            } else {
                                Toast.open({
                                    message: e,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            }
                        })

                    } else if (result.isDenied) {
                        console.log("112 do nothing")
                    }
                })
            }            
        },

        updateData(data,newDataType) {
            console.log("entering updateData with")
            console.log(data)
            let self = this;

            var name = data.name;
            var points = data.points;
            var dataType = newDataType;
            var restrictAwardBy = data.restrictAwardBy;            
            var scaleLimit = data.scaleLimit;
            var submissionLimitType = data.submissionLimitType;
            var submissionLimit = data.submissionLimit;
            var colour = data.colour;
            var selectedColour = data.colour;
            var initialSelectedColour = data.initialSelectedColour;
            var info = data.info;
            var isMandatory = data.isMandatory;
            var isRemarksMandatory = data.isRemarksMandatory

            if ((!name) || (name.length < 1)){
                Toast.open({
                    message: "Please enter the item name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                name = name.trim()
            }
            if (!points){
                points = 0
            }
            if (dataType != 3){
                if (points == 0){
                    Toast.open({
                        message: "Please enter the points for this item",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }
            if (dataType == 4){ //set some default values for parents app
                restrictAwardBy = 1;
            }
            if (dataType != 1){
                isMandatory = 0;    //isMandatory is only available for normal item
            }
            if (restrictAwardBy != 1){
                isMandatory = 0;    //isMandatory is only available for item that can be submitted by all
            }
            if (!colour.hex){
                selectedColour = initialSelectedColour
            }else{
                selectedColour = colour.hex
            }

            if (scaleLimit > 50){
                this.$swal('Sorry, scale limit can not be more than 50!');
                return false;
            }else{
                scaleLimit = parseInt(scaleLimit)
                if (scaleLimit === parseInt(scaleLimit, 10)){
                    if (scaleLimit < 1){
                        Toast.open({
                            message: "Please enter maximum scale for the item " + name,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }
                }else{
                    Toast.open({
                        message: "Please enter maximum scale for the item " + name,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }

            if (submissionLimitType < 1){
                this.$swal({
                    title: "Are you sure? ",
                    text: "Are you really sure you want to set this item " + name + "'s submission count to UNLIMITED?",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: `Yes, make this item submission UNLIMITED`,
                    denyButtonText: `No, let me fix this`,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.continueUpdate(self,data._id,name,points,dataType,restrictAwardBy,scaleLimit,submissionLimitType,submissionLimit,selectedColour,info,isMandatory,isRemarksMandatory)
                    } else if (result.isDenied) {
                        return false;
                    }
                })
            }else{
                submissionLimit = parseInt(submissionLimit)
                if (submissionLimit === parseInt(submissionLimit, 10)){
                    if (submissionLimit < 1){
                        Toast.open({
                            message: "Please enter the daily or yearly submission limit for the item " + name,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }else{
                        this.continueUpdate(self,data._id,name,points,dataType,restrictAwardBy,scaleLimit,submissionLimitType,submissionLimit,selectedColour,info,isMandatory,isRemarksMandatory)
                    }
                }else{
                    Toast.open({
                        message: "Please enter the daily or yearly submission limit for the item " + name,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }
        },

        continueUpdate(self,_id,name,points,dataType,restrictAwardBy,scaleLimit,submissionLimitType,submissionLimit,selectedColour,info,isMandatory,isRemarksMandatory){
            console.log("entering continueUpdate")

            self.isLoading = true
            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/item/update", {
                    superEmail: localStorage.getItem("superEmail"),
                    _id: _id,
                    name: name,
                    points: points,
                    dataType: dataType,
                    restrictAwardBy: restrictAwardBy,
                    scaleLimit: scaleLimit,
                    submissionLimitType: submissionLimitType,
                    submissionLimit: submissionLimit,
                    colour: selectedColour,
                    info: info,
                    isMandatory: isMandatory,
                    isRemarksMandatory: isRemarksMandatory
            }).then(response => {
                if (response.data.success == true) {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                } else {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
                self.isLoading = false;
            })
            .catch(e => {
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Super/ItemList.vue